import React from 'react'

export const PointsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#2C3490" />
      <path
        d="M14.208 13.3437C16.2977 13.3437 17.9918 11.6358 17.9918 9.52903C17.9918 7.42224 16.2977 5.71436 14.208 5.71436C12.1183 5.71436 10.4242 7.42224 10.4242 9.52903C10.4242 11.6358 12.1183 13.3437 14.208 13.3437Z"
        fill="#797EB5"
      />
      <path
        d="M17.9923 9.52374C17.9923 13.7318 14.6043 17.1429 10.4247 17.1429C6.24516 17.1429 2.85718 13.7318 2.85718 9.52374C2.85718 7.4199 4.55117 5.71436 6.64076 5.71436C8.73035 5.71436 10.4243 7.4199 10.4243 9.52374C10.4243 11.6276 12.1183 13.3331 14.2079 13.3331C16.2975 13.3331 17.9915 11.6276 17.9915 9.52374H17.9923Z"
        fill="white"
      />
    </svg>
  )
}
